 <div ng-show="ctrl.attr.sides.left.show && ctrl.attr.sides.left.columns > 0" id="tcqi-leftSide" class="mdl-cell--{{ctrl.attr.sides.left.columns}}-col tcqi--with-scroll">
    <div ui-view="leftSide"></div>
  </div>

  <div  id="tcqi-content" 
        ng-show="ctrl.attr.content.columns > 0"
        class="mdl-cell--{{ctrl.attr.content.columns}}-col tcqi--with-scroll tcqi-expand-layout-to-bottom">
      <dynamic-submenu class="mdl-grid--no-spacing" permits-object="$root.permisos"></dynamic-submenu>
      <itec-breadcrumb></itec-breadcrumb>
      <div ui-view="content"></div>
  </div>

  <div ng-show="ctrl.attr.sides.right.show && ctrl.attr.sides.right.columns > 0" id="tcqi-rightSide" class="mdl-cell--{{ctrl.attr.sides.right.columns}}-col ">
      <div ui-view="rightSide"></div>
  </div>